var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewList = function SvgViewList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28V18h10v10H0zm2-8v6h6v-6H2zm-2-6V4h10v10H0zm2-8v6h6V6H2zm12 0h18v2H14V6zm12 4v2H14v-2h12zM14 22v-2h18v2H14zm0 4v-2h12v2H14z",
    fillRule: "evenodd"
  })));
};
export default SvgViewList;